import React from 'react';
import { Badge, Row, Col } from 'react-bootstrap';
import { Person, Building, CurrencyEuro, Wallet, CreditCard, Cart3 } from 'react-bootstrap-icons';

const ProfileTop = ({ userName, customerName, balanceLCY, balanceDueLCY, creditLimitLCY, outstandingOrdersLCY }) => {
    return (
        <div className="profile-top-modern mb-4">
            <Row className="g-3 align-items-center">
                <Col xs={12} md={4} lg={2}>
                    <div className="profile-item">
                        <Person className="profile-icon" />
                        <div className="profile-content">
                            <small className="profile-label">User</small>
                            <strong className="profile-value">{userName}</strong>
                        </div>
                    </div>
                </Col>
                <Col xs={12} md={4} lg={2}>
                    <div className="profile-item">
                        <Building className="profile-icon" />
                        <div className="profile-content">
                            <small className="profile-label">Customer</small>
                            <strong className="profile-value">{customerName}</strong>
                        </div>
                    </div>
                </Col>
                <Col xs={6} md={4} lg={2}>
                    <div className="profile-item">
                        <CurrencyEuro className="profile-icon text-success" />
                        <div className="profile-content">
                            <small className="profile-label">Balance</small>
                            <strong className="profile-value text-success">{balanceLCY}</strong>
                        </div>
                    </div>
                </Col>
                <Col xs={6} md={4} lg={2}>
                    <div className="profile-item">
                        <Wallet className="profile-icon text-warning" />
                        <div className="profile-content">
                            <small className="profile-label">Due</small>
                            <strong className="profile-value text-warning">{balanceDueLCY}</strong>
                        </div>
                    </div>
                </Col>
                <Col xs={6} md={4} lg={2}>
                    <div className="profile-item">
                        <CreditCard className="profile-icon text-primary" />
                        <div className="profile-content">
                            <small className="profile-label">Credit Limit</small>
                            <strong className="profile-value text-primary">{creditLimitLCY}</strong>
                        </div>
                    </div>
                </Col>
                <Col xs={6} md={4} lg={2}>
                    <div className="profile-item">
                        <Cart3 className="profile-icon text-info" />
                        <div className="profile-content">
                            <small className="profile-label">Orders</small>
                            <strong className="profile-value text-info">{outstandingOrdersLCY}</strong>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default ProfileTop;
